import { omit } from 'ramda';
import { UseUserQuery_user as User } from '../generated/types/UseUserQuery';
import { tc } from './trackingContext';
import { isClientSide } from './isClientSide';
import { AuthPayload } from './authenticate';

export const identifyUser = (user: AuthPayload | User) => {
  if (!isClientSide()) return;

  if (user.id != null) {
    tc.identify(user.id, omit(['id'], user));
  } else {
    tc.identify();
  }
};
